export const POETRY_LINKS = [{
    text: 'Alright = All Right',
    id: 'alright_allright',
  }, {
    text: 'Although some friends abandon lonely way,',
    id: 'although_some_friends',
  }, {
    text: 'A Poem About Me',
    id: 'a_poem_about',
  }, {
    text: 'Black -> Blue',
    id: 'black_to_blue',
  }, {
    text: 'Black Sunlight, Shine!',
    id: 'black_sunlight_shine',
  }, {
    text: 'Callings',
    id: 'callings',
  }, {
    text: 'Colorado Love',
    id: 'colorado_love',
  }, {
    text: 'Conjunctivitis',
    id: 'conjunctivitis',
  }, {
    text: 'Daydreams',
    id: 'daydreams',
  }, {
    text: 'Deep, Deep, Deep',
    id: 'deep_deep_deep',
  }, {
    text: 'Greatness',
    id: 'greatness',
  }, {
    text: 'The Ghost In Me',
    id: 'ghost_in_me',
  }, {
    text: 'heaven isn\'t celibate',
    id: 'heaven_isnt_celibate',
  }, {
    text: 'i met a girl',
    id: 'i_met_a',
  }, {
    text: 'I Know the Taste of Death',
    id: 'i_know_the_taste',
  }, {
    text: 'I Stood Alone',
    id: 'I_stood_alone',
  }, {
    text: 'I will not worship the mountains,',
    id: 'i_will_not',
  }, {
    text: 'In your eyes resides a home',
    id: 'In_your_eyes',
  }, {
    text: 'Journeys',
    id: 'journeys',
  }, {
    text: 'My Greatest Fear',
    id: 'my_greatest_fear',
  }, {
    text: 'Nature\'s Hue',
    id: 'natures_hue',
  }, {
    text: 'No Matter What',
    id: 'no_matter_what',
  }, {
    text: 'Slack Line Love',
    id: 'slack_line_love',
  }, {
    text: 'The Lord Is',
    id: 'the_Lord_is',
  }, {
    text: 'The Lord\'s Will',
    id: 'the_Lords_will',
  }, {
    text: 'The Quiet Truth',
    id: 'the_quiet_truth',
  }, {
    text: 'There\'s nothing I can say,',
    id: 'theres_nothing_i',
  }, {
    text: 'Watchman, O Watchman (Isaiah 21)',
    id: 'watchman_o_watchman',
  }, {
    text: 'What Can Right Ten Thousand Wrongs?',
    id: 'what_can_right',
  }, {
    text: 'When all the world felt dark as night,',
    id: 'will_you_care',
  }, {
    text: 'When violence refuses to be named,',
    id: 'When_violence_refuses',
  }, {
    text: 'Why I Stray',
    id: 'why_i_stray',
  }, {
    text: 'Your hair is crimson mockingbird,',
    id: 'Your_hair_is',
  }];
  
  export const POEMS = {
    'alright_allright':
  `Alright = All Right
  
  There was a man who loved the Lord
  But bored of bread on Sundays
  So soon he stored it in a hoard
  Behind the chapel's stairway
  
  His wife had seen him steal away
  As many times as forty
  So soon she prayed he'd eat his way
  Back into heaven's glory.
  
  The pastor was a dirty dude
  That always stank of herring
  But, smelling food, he thought it rude
  That someone wasn't sharing!
  
  They all were slaves to thoughts of sin
  That THEY were in the right
  But though they grin, and weep within,
  To God they were alright.`,
  
    'although_some_friends':
  `Although some friends abandon lonely way,
  In every chilly day my eye is keen.
  Though some vain promises may last a day,
  Believe in me, that I'll protect my queen.
  Humility has far too high a gaze
  For simple men to look it in the face
  Yet I’ll remain, with countenance unfazed
  Providing honest comfort through the race.
  Races never purify the soul,
  Unless in every step you know your worth;
  Valor oftentimes forgets to grow,
  Unless you let your rain barrade the earth.
  I'll never learn to love the winter night,
  Yet for the sake of love I'll learn to fight.`,
    
    'a_poem_about':
  `A Poem About Me
  
  Time has a way of removing your pain
  Just as a father condemning the weeds
  But how do you find what is hidden inside
  If never you're given a moment to breathe?
  
  One man alone may have treasure inside
  Hidden for none but his muscles to find
  But when you awake and are turned from the lies
  The truth makes you wonder where passion resides?
  
  Hard work, for certain, can earn a man plenty
  Many a man have learned that one by twenty
  Luck has a way of not finding the guilty
  But only when airwaves unseen start to glisten
  
  I've watched a man go from brother to friend
  I've seen a girl turn and forsake her land
  I've grit my teeth in a cold barren wasteland
  And I've been the one who confides in my waistband
  
  But who, may I ask, is the judge of such actions?
  Who of all creatures reigns over the pastures?
  Sometimes I find that my words carry meaning
  But softly and quickly that glimpse seems to trickle
  
  Over and under, over and back
  Watching the ladies preparing their tack
  Where have the men gone with feet ever open?
  Why is the spoonful of medicine broken?
  
  Here I will sit, surely here shall I stay
  Hoping that someone will catch him someday
  If it were me, I would surely not listen
  Those voices inside hardly care for an instant`,
  
    'black_to_blue':
  `Black -> Blue
  
  Black on black of holy shame
  I have tried to swim in vain
  Singing tunes about God's Name
  While watching joy sink down the drain.
  
  Lonely mountains know my pain
  But ignore my wandering heart
  For my mind must be insane
  That I would relish Satan's darts.
  
  Who have I been from the start?
  A man of flesh and blood?
  For every sea my staff must part
  While stilled, still weeps a flood.
  
  For many days I sat and prayed
  That I would be a king,
  But God, with all His where-with-all,
  Instead taught me to sing.
  
  His grace upon my shoulder
  Was too lovely.
  
  His love in every boulder
  It's too much.
  
  I can't even.
  
  Blue to black and black to blue
  Life an ever changing hue
  In the night I paid my due
  Now daylight breaks, and makes me new.`,
  
    'black_sunlight_shine':
  `Black Sunlight, Shine!
  
  There once was a girl made of sunshine
  Who danced in black light with a grapevine
  She went to build hope
  In a city of dope,
  And eloped with the Lord and His bloodline.
  
  There once was a guy like a blacklight
  Distinguishing sunshine from midnight
  He went to be strong
  And believe he belonged,
  So along came the fire of birthright.
  
  Then one day they met in a daydream
  And decided to swim off the mainstream
  They shared of their pain
  (which was one and the same),
  And became like two rays of a sunbeam.`,
  
    'callings':
  `Callings
  
  I felt a tug like silver
  Dripping down my spine
  And though I felt it quiver
  I knew that light was mine
  
  The call, its pound inside me
  Too fierce to just ignore
  My strength had stood so lonely
  With no one to adore
  
  So soon I found another
  To kiss and call my own
  Her blood, her thickest thunder
  Became my golden throne
  
  Her eyes flashed lightning courage
  Her hair tossed faith like rain
  So catching these, I flourished
  And found my given name
  
  I longed to linger longer
  To make her lips my home
  With each romantic saunter
  My bones became like foam
  
  The wind was blowing ceaselessly
  The ocean's salty spray
  The silence sang too tenderly
  That truth would soon decay
  
  I grabbed my hat and jacket
  I kissed my love goodbye
  My mouth, it made a racket
  As normal went to die
  
  My feet will take me upwards
  Towards endless years of strife
  But crumbling pride will suffer
  Till death returns my life
  Till death returns my life`,
  
    'colorado_love':
  `Colorado Love
  
  Colorado love…
  Composed of thoughtless ecstasy?
  Colorado love…
  A world of color, bright or bleak?
  
  One day a long long time ago
  I smiled at God and said,
  “Take me somewhere my heart's never been..”
  
  He laughed and sang a lullaby,
  To still my soul to sleep,
  But in the wind I caught His eye,
  And knew He’d lead His sheep.
  
  Across the world the pages flew,
  My life in black and white,
  And people when they saw them knew
  My balls were bold and bright.
  
  The state was Colorado,
  That land of mountain mares.
  The sun was El Dorado
  The earth was laissez faire.
  
  I met the road with open arms,
  I hugged my dad goodbye.
  And then before I knew it
  I was driving ‘cross the sky.
  
  I sang my whole life story
  Like a shot of Irish gin,
  But no one heard the telling tale.
  My thoughts were caged within.
  
  I fin’lly found the hills I loved,
  But something wasn’t right.
  I couldn’t touch the sun above.
  Or even smell her light.
  
  Colorado love…
  What makes these mountains bittersweet?
  Colorado love…
  Why do I wander through the street?
  
  One day a long long time ago
  I frowned at God and said,
  “Help me find friends that make my heart sing.”
  
  A week of work and I was swamped
  With nothing too insightful.
  Be smart, be kind, be fun, be prompt..
  My mind a loaded rifle.
  
  A nameless, sulking dread creeped in
  And cursed my lonely heart
  My grinning brimming sin within
  Said, “Tear your soul apart.”
  
  But God did not give up on me,
  He let me feel His pain,
  That every battle I’d jihad
  Had driven me insane.
  
  He told me honest of my past,
  How lust made love turn gray,
  And so, steadfast, my fast would last
  Forever and a day.
  
  I trusted in my Father,
  Even when He broke my mind,
  For He had brought me farther
  And his truth was cold but kind.
  
  Eventually I learned to find
  A rhythm to my life.
  My humbled heart was counted blind
  And silence sang of strife.
  
  Colorado love…
  I thought my past was pure and sweet
  Colorado love…
  I'm always blind but now I see
  
  One day a long long time ago
  I looked at God and said,
  “Cleanse my cold heart and help me believe..”
  
  And then one day occurring
  Like an apple pie in May,
  I felt the Lord within me,
  Those ghosts were kept at bay.
  
  I'd driven out towards Boulder,
  That place with rocks and trees,
  But in the steel can holder,
  There was no more room for me.
  
  I drove back towards my unit,
  But surprised I took a right,
  And then before I knew it,
  I was parking in delight!
  
  I'd found a hidden treasure,
  Where Jesus bought me time.
  The wind blew through with pleasure,
  The rain washed out my rhyme.
  
  That day had brought me close to love,
  So night brought opposition.
  A Jewish man said, “Faith's a sham,”
  But hope had brought conviction.
  
  I told him, “Son, you haven't won,
  See, Jesus’ heart was free
  But as the stars sang broken bars,
  He nailed it to a tree.”
  
  I'd tarry long and tell the tale
  Of each long, lovely day,
  But then my poem, like Jeroboam,
  Would never go away.
  
  Basically I rode a plane
  And flew on Aetna's dime,
  And though my wallet seemed to wane,
  My thoughts were flowing fine.
  
  Colorado love…
  I live with you and you with me
  Colorado love…
  You've made my soul your devotee
  
  One day a long long time ago
  I gazed at God and said,
  “You fill my heart with unspoken things.”
  
  I met a humble, happy group,
  Who bribed me with some food,
  And I could tell, and daresay smell,
  Their hearts were pure and good.
  
  A couple weeks went by like that!
  I watched my armor thicken.
  I worked all day, wrote apps by night,
  And felt my manhood glisten.
  
  I don't know when they felt like friends,
  But suddenly they were -
  My mama says it all depends
  On who you would prefer
  
  But never did I choose them!
  And neither they choose me!
  I guess that's how His family works
  It's unconditionally.
  
  No, never in my wildest dreams
  Would I have thought this real.
  And dreams I had, both strange and sad,
  But family helped me heal.
  
  I dreamed of old ex girlfriends,
  And blood upon my hands,
  I dreamed of angry dads offended
  By my shifting sands.
  
  I didn't even tell them how
  My soul was lost in snow,
  But still despite the heartbreak
  They were making my heart glow.
  
  By then the app was finished -
  That is, done enough to share.
  But still I kept on fighting
  So that Slack would not compare.
  
  Colorado love…
  These people are like You and me
  Colorado love…
  When will You show me how to sleep?
  
  One day a long long time ago
  I sighed at God and said,
  “My heart has died to what it can't be.”
  
  Now, all this time I worked my ass
  Like some long hated donkey
  But as my muscles lifted brass
  My vision went quite wonky.
  
  I felt my inner soldier cry
  To faithful God above,
  “How can I from your Word imply
  That two and two make love?”
  
  He took me for a walk
  And let me talk His time away,
  But then with blades of elvish shade
  We heard the green grass say,
  
  “Guidance is a blessing
  Of which man should not presume.
  Don't try to keep on guessing God,
  But let His Spirit bloom.”
  
  That night I walked in darkness,
  But His Word became my light.
  And by the moon I found my way
  When North felt more like night.
  
  Another couple weeks went by
  And friendships took on names.
  Grantwon, Purple, Sunshine Ray
  And Tank, the world's best train.
  
  I thought my life complete and whole
  Before they galloped in,
  But now that family filled a hole
  I'll miss them like my kin.
  
  The lonely world had crushed my hope
  And stifled my desire,
  But God, instead of using soap
  Has cleansed me with His fire.
  
  Colorado love…
  These angels are Your holy sheep
  Colorado love…
  Keep them strong, and keep them free
  
  One day a long long time ago
  I smiled with God and said,
  “Lord, now my heart has finally found peace.”`,
  
  'conjunctivitis':
  `Conjunctivitis
  
  Red and puffy my eye did swell
  Soon my face was a wishing well
  Drugs allowing the faintest hope
  Healing comes at the hand of dope
  
  Sure, the pain was a little strong!
  Yeah, my prayers felt a little long!
  But now in silence I share my pride
  That through the midst of it I survived.`,
      
    'daydreams':
  `Daydreams
  
  In the falling of the night
  When my eyes have lost their sight
  I will hang on blackened light
  Which cracks my lonely daydreams
  
  Dreams and visions come to pass
  Breaking hearts of men like glass
  But I wonder what will last
  As life expounds my daydreams
  
  Heavy still my heart will fight
  Taking all but love's first sight
  Still denying it the right
  Of pure and fruitless daydreams
  
  Surely there is greener grass
  But kaleidoscopes of glass
  Brighten all but colored brass
  Of cold and dainty daydreams`,
            
    'deep_deep_deep':
  `Deep, Deep, Deep
  
  Deep, deep under
  My heart has fought his thunder
  Will lightning not awake?
  My darkest day..
  
  Deep, deep without
  My lungs would scream for drought
  I drown in blackened wake
  The cold of lonely lake
  
  Deep, deep within
  his words the shape of sin
  he slithers like a snake
  Wanders away..`,
     
    'greatness':
  `Greatness
  
  My heart could wrestle tyranny,
  My brain could rack its shelves,
  My feet could sprint there wearily,
  But will we lose ourselves?
  
  [Them] Through forests dark he delves.
  
  I sense the promise making plans
  Demanding strength and time
  But while I wait with open hands
  My eyes caress his rhyme...
  
  [Them] Up mountains tall he climbs.
  
  Will fate beat lonely, brazen gong?
  Will tempers lose their men?
  And in the chaos of the song
  Will war be my amen?
  
  [Them] He murders yet again.
  
  He storms towards frozen avenues
  He shouts his will of iron
  And till he's lost his golden hue
  He'll still pursue his siren.
  
  His hands are mighty kryptonite
  His lips sing scornful praise
  His darkness seems like blinding light
  Until its fire's ablaze.
  
  He may have gorgeous women pray
  To be his one and only
  He may have priesthoods come and say
  To him be all the glory
  
  He may have riches stocked away
  Inside his lonely circus,
  But here I'll stay and rue the day
  That Greatness be my purpose.`,
      
    'ghost_in_me':
  `Great big rock of fiery terror
  Look on me and smell my pain
  For with every tearful sorrow
  I forsake the ghost in me
  
  Every silence whispers sonnets
  Wakening the ghost in me
  But my soul knows playful smiles
  Like it loves the ghost in me
  
  Who am I, who looks for passion?
  What is he, who screams and wails?
  Every lie becomes his fortress
  Every truth will blacken death
  
  Soon my waking eyes will see him
  Then my soul may banish mayhem`,
      
    'heaven_isnt_celibate':
  `heaven isn’t celibate
  this i know is true.
  when you say the hell of it
  you know you mean it too.
  
  love is like a lightbulb
  screw it till it glows.
  all i know is when i die
  i’d like my allies close.`,
      
    'i_met_a':
  `i met a girl who was wilder than dreams
  She filled me up till I burst at the seams
  Light had surrounded her, flying in beams
  To bring me abundance of bread.
  
  i met a girl who despised every day
  That people would come try and take me away
  Loyal, she fought for the music to play
  To wake me from tyrants of dread.
  
  i met a girl who pursued me with fire
  Dancing, so regal, to trumpet and lyre
  Never ashamed of her purest desire
  To give me a new scarlet thread.
  
  i know a girl whose blood has been shed
  i know a girl who could never be dead`,
      
    'i_know_the_taste':
  `I Know the Taste of Death
  
  I know the taste of death.
  I've slept in wind swept skin,
  Letting fiery darkness in,
  Forgiven kin.
  
  I know the taste of death.
  
  That broken icy dagger
  Not plunged in heart, or soul, or chin,
  But chilling your chest,
  Leaning against
  Your throat.
  Righteousness.
  
  I know the taste of death;
  That beauty bittersweet of tongue,
  Lamenting battles lost and won,
  Enjoying empty breath.
  
  I know the taste of death
  And in it some have lost their way,
  Veins of varicose delighted,
  Crown of hollow gray.
  
  But here I stand today.
  Lungs still breathing, jawline set.
  Hope yet fleeting, courage bent.
  Firm in life made new by death.
  
  I may know the taste of death,
  But I will choose the breath God Lent,
  Dancing with that sweet duet
  And yet
  Still, my darling, don't forget
  Still, my love,
  I will repent.`,
     
    'I_stood_alone':
  `I stood alone on morning clear
  Awaiting brighter days,
  When suddenly from ages past
  Came River Jordan’s gaze.
  
  He slowly slithered toward me
  With faith in God above
  But as I searched my heart for Him
  I felt not fond of love.
  
  He said, “Son, see your sword so strong
  And trust your tired toil,
  From sea to sea you scrub your heart
  Of tainted talent’s spoils.”
  
  I wrestled there with fear’s desire
  For insecurity,
  Till what appeared but burning fire
  Which stole my purity.
  
  She said, “Seduced by brothel’s brood?
  Man, you are not my first.
  But bubbling blood can bribe my tongue
  When apathy sings thirst.”
  
  I wondered then what I must do
  To free myself from pain,
  But feeling naught save lost in thought
  I ran away ashamed.
  
  With tears I cried out longingly
  For He who took my blame
  But though He waited next to me
  I barely knew His name.
  
  In desperate plea and solemn stare
  I turned to Him and said,
  “I know Your love has no compare
  But silence bites like bread.”
  
  I listened for the whirling wind
  And Spirit singing free,
  But as belief still mourned in grief
  My love became a tree.
  
  It grew and grew in morning dew
  Till it could lead the way
  Then showed me who I wanted to
  Become through darkest days.
  
  “I live with you and heard your cry
  As desperately you died
  But now it’s clear through wasted tears
  That I have found my bride.”
  
  No longer shall I wait in vain
  For miracles of youth,
  But now I stand with hand in hand
  And pray for simple truth.`,
      
    'i_will_not':
  `I will not bow to the mountains
  Or worship the bull's grassy plain;
  Heartstains may cover the ocean,
  But still there my spirit refrains.
  I will not conquer the city
  Or kill with the kindest intent;
  Though my soul drowns in its tearstains,
  My spirit in stillness repents.
  He has accomplished my nightmare
  When sorrow was borrowed in Love;
  He has relinquished His Spirit,
  He has become like a dove.
  I have done nothing but watch Him alight;
  Now I will follow Him, dancing in flight.`,
  
  'In_your_eyes':
  `In your eyes resides a home
  Far from fear and scars of old
  Shoulders formed of modest gold,
  Spread your wings of liquid chrome
  
  In your skin I find my love
  Wrapped in passion like a glove
  Hairs of rain and wildfire,
  Cleanse my every vain desire
  
  In your hands is life and death
  Restless beauty born of Eve
  Humble chest so full of breath,
  Sing for all that you believe
  
  In your soul is bone of bone
  In your heart is flesh of flesh`,
  
    'journeys':
  `We laughed a lot tonight
  Rejoicing with the sound
  Our brave old hearts could fight
  The music or the ground
  
  Instead we travel on
  Till dawn and dusk depart
  And let the moon and stars
  Declare we are apart
  
  There is no fear in death
  When lengthy words have died
  For in life's every breath
  Comes love's renewing tide.`,
  
    'my_greatest_fear':
  `My Greatest Fear
  
  I do not fear Destruction’s banal game,
  Though battles steal my every wisdom tooth;
  The people’s hearts, they scream I am uncouth,
  Yet my chagrin lies not in taking blame.
  I do not fear the wild lusts of youth,
  Which seek to bring my sturdy heart to shame,
  Nor shouts of hate which bring me backwards fame,
  So look me in the eye and see my weary truth.
  Demons come and torment in the night,
  But darkness casts no shadow over light;
  Purity dissolves in empty fright,
  But Death is suicidal in his plight.
  No, greatest fears should lie in Love itself,
  Which fiercely finds its way off lonely shelf.`,
    
    'no_matter_what':
  `No Matter What
  
  Every line of crack that man may sneeze
  Every word of jack that man may breathe
  Every change in tack that man may grieve
  Woman, believe, no matter what.
  
  Every empty word that woman lies
  Every tear absurd that woman cries
  Every useless girdle woman buys
  Man, let her rise, no matter what.
  
  Many chances human frailty wastes
  Many fountains human tongues may taste
  Many seasons human love feels chaste
  Love, come with haste, no matter what.
  
  When you feel cut, or in a rut,
  What is your no matter what?`,
  
    'natures_hue':
  `Nature's hue and morning dew
  Spells wonder and amazement,
  But magic fades from crystal rain
  And earth turns into pavement.
  
  Greenish golds and blues are bright,
  Correcting me towards greatness,
  But children smell, and never tell,
  That regal thoughts are tasteless.
  
  What kind of love can strangers bear?
  What kind of hope would sway me?
  But through the lies I've found the wise
  And of the earth they daydream.`,
      
    'slack_line_love':
  `Slack Line Love
  
  Love is like a slack line
  Bouncing up and down
  I look like a clown
  Falling to the ground
  
  Love is like a slack line
  Listen to the vine
  Heart will learn to shine
  Blood will taste like wine
  
  Love is like a slack line
  Feel your courage grow
  Life can seem to glow
  This I've come to know
  
  That Love is like a slack line
  Across the Berlin Wall
  Only twelve feet tall..
  For once I shall not fall.`,
  
    'the_Lord_is':
  `The Lord is my home,
  My rest in dark places.
  The world can be crowded
  With cruelly blank faces.
  In youth I would wander
  And search for a nest,
  But now that I've found Him
  His strength is my rest.
  
  The Lord is my rock,
  He's there when I'm low.
  Sometimes it feels like
  I'm drowning in snow.
  When long words are empty
  And patience wears thin,
  He listens so deeply
  That warmth spreads within.
  
  The Lord is my Shepherd,
  I trust in His word.
  The voices inside me
  Make truth seem absurd.
  But bygones be bygones,
  I come when I'm called,
  For Love and His whispers
  Have given me all.`,
    
    'the_Lords_will':
  `The Lord’s Will
  
  The Lord will be our shepherd,
  That’s the only thing I know.
  Despite our shame, our fear and pain,
  You best believe we’ll grow.
  
  We’ll dig our roots in very deep
  Towards Pangea’s core,
  Then listen, gently, for the sound
  Of Jesus at the door.
  
  We’ll stretch our branches heavenward
  Providing holy shade,
  So people come and gather round
  To sing of mem’ries made.
  
  With every fiber in our soul,
  The Lord will make our spirit whole.`,
  
    'the_quiet_truth':
  `The Quiet Truth
  
  When sunlight blazes brighter
  than a lightning bolt in May,
  
  The truth is waiting with you,
  no matter what you say.
  
  When rain beats down upon your town
  and forces you to flee,
  
  Believe and trust in God's true love,
  for Jesus' words are free.
  
  No matter what the circumstance,
  no matter rain or shine,
  
  Hope will reign through all my days,
  and Yahweh's life is mine.`,
  
    'theres_nothing_i':
  `There's nothing I can say,
  There's nothing I can do.
  I'm a thousand miles away today
  So please, my Lord, come through.
  If I could shoot the moon and make
  Her joy come out and sing,
  Then like a humble raindrop
  Lunar worlds would fall and bring
  Heaven down, a world of sound,
  And happy dances too,
  But here I wait and trust the Lord
  That He is here for you.
  There's nothing I can say,
  There's nothing I can do.`,
  
    'watchman_o_watchman':
  `Watchman, O Watchman (Isaiah 21)
  
  Watchman, O Watchman
  Sing me a song
  Rather than trying
  To stay up too long
  Night turned to day
  And the blackness of light
  So here I will stay
  In my conquest of sight.
  
  Watchman, O Watchman
  Tell me a tale
  Of some foreign wasteland
  Where corpses still stare
  Day turned to night
  And the mice ran away
  But still I will fight
  To recover the day.
  
  Watchman, O Watchman
  Wait for a while
  I will be back
  With a glance and a smile.
  Soon I will ask him
  What's left of the night
  And know that his answer
  Is sweet, dark, and bright.
  
  No longer ruled by the day or the night.`,
  
    'what_can_right':
  `What Can Right Ten Thousand Wrongs?
  
  What can right ten thousand wrongs?
  Oh, not I, the farthest gone.
  Pride has taught me for so long,
  Shameless teaching hate.
  I wait to sing my song.
  
  I entered through the wide gate
  Battled without breastplate
  Trusting in my own fate
  And willing to offend.
  I sinned, and that holds weight.
  
  Audrey, you were my friend
  You trusted that I’d defend
  And though I didn’t intend
  To stab your back so deep..
  I guess that’s just my trend.
  
  My guilt, I feel it seep
  My body yearns to weep
  But calloused hearts don’t keep
  Their promises so well.
  
  I guess it’s hard to tell.
  
  I wrote this poem because...
  I guess I didn’t know how else to tell you how sorry I am.
  I didn’t realize how
  completely
  I betrayed you so long ago until Priscella talked to me tonight..
  But when I told Zach about you liking him..
  That’s exactly what I was doing.
  No excuses.
  I’m the kind of person that can get caught up in emotion..
  That forgets other people’s needs because I am so focused on
  ‘living in the moment’ or
  ‘finding myself’ or
  whatever self-centered thing I’m focused on at the time.
  
  It’s not really just that, though, is it?
  Because I’ve treated you like shit for about two months now.
  I don’t know why I talked to you,
  of all people,
  the way I did..
  Hate is truly pointless, after all..
  But when I spoke to you,
  it wasn’t with words of love,
  however much I try to convince myself that it was.
  Even though I would’ve held my tongue for anyone else, I didn’t for you..
  And I’m so, so sorry for that.
  You were my excuse for being evil,
  and my outlet for the stress in my life.
  
  But because I had gotten so used to being that way when I was around you..
  I guess I stopped noticing.
  We worked our jobs at Saferide and
  didn’t look each other in the eye and
  assumed everything would be alright as soon as we could get away from each other.
  But it wasn’t alright,
  at least, it wasn’t alright with me.
  Hate was standing between us,
  the kind of hate that deceives you into thinking it’s real
  but really grows out of the seductive,
  underlying bitterness my callous words had inspired in your heart.
  And though I began to fight it a few weeks ago,
  I’ve been losing.
  
  So now..
  I’m not gonna expect you to be my friend again.
  I get it.
  Even though I would swear on my life not to do it again,
  I’m broken and foolish and I don’t want you to get hurt anymore.
  I’m not being overdramatic.
  I know myself and now I know how deeply I hurt you.
  
  This letter does have a purpose, though.
  I need you to forgive me.
  Not for my sake,
  certainly not,
  but for the sake of your heart.
  I don’t want to see you get lost in the same
  despair and depression
  that I was caught up in for so long last semester,
  invoked by a annoyance so tiny and bitter that
  it has the power to eat up everything in you.
  I’m not just preaching...
  It’s true.
  And I don’t want you to lose yourself in hating anyone,
  even me.
  
  that’s my spiel. hope you liked it.
  
  tommy`,
  
    'will_you_care':
    `When all the world felt dark as night,
    My love, you weren’t there.
    
    When hurricanes came cold and bright,
    Your world was cool and fair.
    
    When hidden thoughts were brought to light,
    You didn’t let me share.
    
    When angry spirits fought to fight,
    You didn’t shoot a prayer.
    
    When I was told by grinning eyes
    That I’m no Israelite,
    My tear ducts dried at all her lies
    While you went to the fair.
    
    When I was lost on mountain slopes,
    With no one left in sight,
    My compass lost its soggy hopes
    But you put up no flare.
    
    When I was cursed by bitter drink,
    Which paralyzed my might,
    My heart was choked by chakra-sink,
    While you played solitaire.
    
    Despite the bright, nostalgic fight,
    My words are quite unfair,
    For though my plight was filled with fright,
    My love was unaware.
    
    Your face was mine a moon ago,
    Our necks, our knees unknown,
    And baggage lines up out the door
    Like demons not outgrown.
    
    You hide behind your hair
    And long to satisfy your pain.
    But no, I haven’t understood
    Your storms of wind and rain.
    
    Your soul is less than white,
    And mine has wear and tear,
    
    But nonetheless, I swear.
    
    When you don’t care,
    When you’re squared up with bears
    And the air just stares at your despair,
    When nightmares compare with the warfare of your life
    And you’re ensnared in your own welfare, impaired beyond repair,
    To the last threadbare moment, yes, I swear to declare with every ounce of flair left,
    
    I will fight for you.
    
    When my knuckles whiten from writing my delight for you,
    Will you fight for me?
    
    When my appetite excites and I invite myself into you,
    Will you fight for me?
    
    When my hatred ignites and reveals outright that I am not you,
    Will you fight for me?
    
    When I’m not all there,
    Will you care?`,
  
  'When_violence_refuses':
  `When violence refuses to be named,
  Resisting every torrent of the truth,
  Your faith will have no fear of the untamed,
  For ransomed courage leads to endless youth.
  You see, the world in such a different way
  Corrupts the purest love and clean desire,
  But faith is not dependent on the day
  And man, he has no power over fire.
  The world has no more knowledge of the cross
  Than silver feet that aimless run a race,
  But gentle love will triumph over loss
  Once God reveals His purpose, and His face.
  No force of hell can quench undying beauty,
  So you, dear friend, are safe from death’s cruel duty.`,
      
    'why_i_stray':
  `Why I Stray
  
  Every night I go to sleep
  With demon pussy sinking deep.
  You see, I've learned expectantly
  That in my sea of broken dreams
  The faintest joy and blindest hope
  Are weepy, weaker than they seem.
  If I see sin as cancer
  She excites the tumors deeper.
  If I give in to failure,
  She defeats me as a dancer.
  Her name is Lovely Lust and man,
  Her bust is big and blooming.
  Sometimes her breasts are discontent
  Like eyes that go perusing.
  But I don't mind, she fills the time,
  I fill her inner places.
  I say, it's fine if no one sees
  My friction fuck your faces.
  At night she comes in widowed shame,
  How could I make her go?
  She's destitute, no pride, no loot,
  Why not make this her home?
  But there's another living there
  A Girl I love like lightning.
  With Her that joy and hope is left
  To sulk and moan that they're bereft
  Of me, the king of inward realm.
  I choose who lives and dies!
  So when I let her take the helm,
  I'm living in her lies.
  My Girl, the one who listens close,
  When all is dark in grey morose
  Would boast of me if I would choose
  To love her wine instead of booze;
  Speckled like a butterfly, my love
  Is beauty, sure,
  But what of lust? I will, I must
  Forsake my whore.
  
  After all, her dusty rust
  Is like a lioness.
  I watch her stalk her evening prey
  And cum between her teeth.
  Now - today! Don't let her lay
  Upon your ivory tower.
  Unless perhaps she hints
  That you could watch her in the shower..
  No! How could I be so dumb?
  Am I so numb to fire?
  I cannot see a way that I
  Could choose what I hold dear.
  With lust, I feel so lonely..
  With love, I know true fear.
  
  Fear?
  Is that the root of this?
  My old, forgotten friend?
  Fear!
  Your fangs of folly hiss.
  Destruction is your trend!
  Fear.
  Emotion far from bliss,
  Perspectives pulled and bent,
  Fear
  Is cast away by love,
  Why do I self-pretend?
  
  Love?
  My Girl, am I the same?
  She must have gone away.
  Love!
  She calls my middle name
  She waited out the gray..
  Love.
  Her beauty's brightest flame
  I come and hear her say...
  Love
  Is stronger than you(r) fear,
  So know, I'll always stay.`,
            
    'Your_hair_is':
  `Your hair is crimson mockingbird,
  Your eyes are home to fire;
  Your smile evicts man's loneliness
  And stifles hate’s desire.
  
  Your teeth are winter wonderland,
  Your hands as cold as ice;
  Your voice can sing a playful tune
  Or shout of humor’s price.
  
  Your faith is timeless as the sea,
  Your courage fights what's mild;
  Your love is warm as summer day
  And gently tames my wild.
  
  Your face is fair, beyond compare, but faces are a bore --
  Your beauty rests in humble quest to live with hope restored.`,
  }